import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Actions } from "@workspace/common";

const RedirectRoute = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [shouldRenderChildren, setShouldRenderChildren] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const redirectToken = queryParams.get("redirectToken");
    if (redirectToken && navigate) {
      dispatch(
        Actions?.fetchLinkByToken(
          {
            token: redirectToken,
            setUsed: false,
          },
          navigate
        )
      );
    } else {
      setShouldRenderChildren(true);
    }
  }, [dispatch, location.search, navigate]);

  if (!shouldRenderChildren) {
    return null;
  }
  // If no redirect, render the children
  return children;
};

export default RedirectRoute;
